// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607241134/js/" + chunkId + "." + {"44":"5c7507b8","225":"9db6c4a4","481":"aaf12a56","486":"140f1b27","770":"9d1e2a72"}[chunkId] + ".0.6859912834427009.chunk.js";
};